module.exports = __webpack_public_path__ + "img/chooseOs copy.11a55f1.svg";